import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_shipment_details_by_shipping_container_idService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerId: number }): 
  Promise<{ result: { Id?: number, CarrierId?: number, Shipment?: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, ExpectedWarehouseId?: number, Notes?: string, Priority?: number, ShippedDate?: string, ShipToAccountId?: number, ShipToContactId?: number, OrderLookups?: { OrderId?: number, Order?: { Id?: number, OrderClassId?: number, PreferredWarehouseId?: number, ProjectId?: number, ThirdPartyWarehouseId?: number, Project?: { Id?: number, Owner?: { Id?: number } }, OrderClass?: { Id?: number, OrderType?: { Id?: number, Name?: string } } } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shippingContainerId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CarrierId?: number, Shipment?: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, ExpectedWarehouseId?: number, Notes?: string, Priority?: number, ShippedDate?: string, ShipToAccountId?: number, ShipToContactId?: number, OrderLookups?: { OrderId?: number, Order?: { Id?: number, OrderClassId?: number, PreferredWarehouseId?: number, ProjectId?: number, ThirdPartyWarehouseId?: number, Project?: { Id?: number, Owner?: { Id?: number } }, OrderClass?: { Id?: number, OrderType?: { Id?: number, Name?: string } } } }[] } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shippingContainerId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CarrierId?: number, Shipment?: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, ExpectedWarehouseId?: number, Notes?: string, Priority?: number, ShippedDate?: string, ShipToAccountId?: number, ShipToContactId?: number, OrderLookups?: { OrderId?: number, Order?: { Id?: number, OrderClassId?: number, PreferredWarehouseId?: number, ProjectId?: number, ThirdPartyWarehouseId?: number, Project?: { Id?: number, Owner?: { Id?: number } }, OrderClass?: { Id?: number, OrderType?: { Id?: number, Name?: string } } } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerId: number    }) {
        if(isNil(inParams.shippingContainerId)) {
          return true; 
        }
      return false;
    }
}
